


















































































































import {
	defineComponent,
	PropType,
	computed,
	onMounted,
	Ref,
	ref,
} from '@vue/composition-api';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { SelectBoxChoice } from '@front-app/components/inputs/SelectBoxModel';
import { useEventMembershipRole } from '@front-app/hooks/useMembershipRole';
import { useRouteQueryArray } from '@front-app/hooks/useRouteQueryArray';
import { EventListQuery } from '@front-app/router/util/eventListQuery';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import ChevronsUpDown from '@front-app/components/icons/chevrons-up-down.vue';
import SearchBox from '@front-app/components/search/SearchBox.vue';
import SelectBox from '@front-app/components/inputs/SelectBox.vue';
import CheckboxList from '@front-app/components/inputs/CheckboxList.vue';
import RoleBadge from '@front-app/components/cards/RoleBadge.vue';
import { EventFilter } from './EventEnum';
import { EventDateChoice } from '../../../hooks/useGoToEventDates';

const FILTER_TO_USER_ROLE: Record<EventFilter, UserRole> = {
	[EventFilter.ADMINISTERED]: UserRole.ADMINISTRATOR,
	[EventFilter.INVITES]: UserRole.INVITEE,
	[EventFilter.REGISTERED]: UserRole.MEMBER,
};

export default defineComponent({
	components: {
		SearchBox,
		SelectBox,
		CheckboxList,
		RoleBadge,
		ChevronsUpDown,
	},
	props: {
		searchValue: {
			type: String,
			required: true,
		},
		selectedGoToDate: {
			type: String,
			required: true,
		},
		monthsAndYears: {
			type: Array as PropType<EventDateChoice[]>,
			required: true,
		},
		currentAccessFilters: {
			type: Array as PropType<EventFilter[]>,
			required: true,
		},
		availableAccessFilters: {
			type: Array as PropType<EventFilter[]>,
			required: true,
		},
		accessFilterCounts: {
			type: Object as PropType<Record<EventFilter, number>>,
			required: true,
		},
		currentTypeFilters: {
			type: Array as PropType<string[]>,
			required: true,
		},
		availableTypeFilters: {
			type: Array as PropType<string[]>,
			required: true,
		},
		currentTopicFilters: {
			type: Array as PropType<string[]>,
			required: true,
		},
		availableTopicFilters: {
			type: Array as PropType<string[]>,
			required: true,
		},
		numVisibleEvents: {
			type: Number,
			required: true,
		},
		numEvents: {
			type: Number,
			required: true,
		},
	},
	setup(props, ctx) {
		// Types in URLs
		const typeUrlQuery = useRouteQueryArray(ctx.root.$router, computed(() => ctx.root.$route), EventListQuery.TYPE, computed(() => props.currentTypeFilters));
		const typeFilters = computed((): SelectBoxChoice[] => props.availableTypeFilters.map((key) => ({ label: ctx.root.$t(key) as string, key })));
		const toggleTypeFilter = (type: string) => {
			if (props.currentTypeFilters.includes(type)) {
				typeUrlQuery.removeVisit(type);
			} else {
				typeUrlQuery.appendVisit(type);
			}
		};
		const clearTypeFilters = typeUrlQuery.clearVisit;
		// End Types in URLs

		// Filters in URLs
		const topicUrlQuery = useRouteQueryArray(ctx.root.$router, computed(() => ctx.root.$route), EventListQuery.TOPIC, computed(() => props.currentTopicFilters));
		const topicFilters = computed((): SelectBoxChoice[] => props.availableTopicFilters.map((key) => ({ label: key as string, key })));
		const toggleTopicFilter = (topic: string) => {
			if (props.currentTopicFilters.includes(topic)) {
				topicUrlQuery.removeVisit(topic);
			} else {
				topicUrlQuery.appendVisit(topic);
			}
		};
		const clearTopicFilters = topicUrlQuery.clearVisit;
		// End Filters in URLs

		// Access filters
		const accessFilterUrlQuery = useRouteQueryArray(ctx.root.$router, computed(() => ctx.root.$route), EventListQuery.FILTERS, computed(() => props.currentAccessFilters));
		const accessFilterButtonList: Ref<SelectBoxChoice[]> = computed(() => props.availableAccessFilters
			// It's possible to have an empty filter selected because of direct navigation, or toggling the "past filter"
			// in this case, it's easiest just to keep the button visible for clarity
			.map((key) => {
				const count = props.accessFilterCounts[key];
				return {
					key,
					label: ctx.root.$n(count),
					disabled: count === 0,
				};
			}));
		const goToAccessFilter = (key: EventFilter) => {
			if (props.currentAccessFilters.includes(key)) {
				accessFilterUrlQuery.removeVisit(key);
			} else {
				accessFilterUrlQuery.appendVisit(key);
			}
		};
		const userRolesForFilter = (key: EventFilter) => useEventMembershipRole(FILTER_TO_USER_ROLE[key]);
		const isAccessFilterSelected = (keyToCheck: EventFilter) => props.currentAccessFilters.some((val) => val === keyToCheck);
		// End: Access filters

		// Dates
		const selectedGoToDateOption = computed(() => props
			.monthsAndYears
			.find(({ key }) => key === props.selectedGoToDate));
		// End dates

		// Responsive view
		const screenWidth = ref(window.innerWidth);
		onMounted(() => {
			window.onresize = () => {
				screenWidth.value = window.innerWidth;
			};
		});
		// eslint-disable-next-line arrow-body-style
		const getDropdownPosition = () => {
			return screenWidth.value < 810 ? DropdownPosition.BOTTOM_LEFT : DropdownPosition.BOTTOM_RIGHT;
		};
		// END Responsive view

		return {
			// Dates
			selectedGoToDateOption,
			// Types
			typeFilters,
			toggleTypeFilter,
			clearTypeFilters,
			// Topics
			topicFilters,
			toggleTopicFilter,
			clearTopicFilters,
			// Access filters
			isAccessFilterSelected,
			accessFilterButtonList,
			goToAccessFilter,
			userRolesForFilter,
			// Util
			getDropdownPosition,
			elide(val: string): string {
				return `${val.substring(0, 2)}…`;
			},
		};
	},
});
